import React, { createContext, useEffect, useState } from "react";
import { fetchCompanyTimezone } from "../services/companyTimezone";

export const TimezoneContext = createContext("UTC");

export function TimezoneProvider({ children }) {
  const [tz, setTz] = useState("UTC");

  useEffect(() => {
    fetchCompanyTimezone().then(setTz);
  }, []);

  return (
    <TimezoneContext.Provider value={tz}>
      {children}
    </TimezoneContext.Provider>
  );
}
